export default class ChatHelper {
  static canChat(user, plan) {
    if (plan.isFreemium()) {
      return false;
    }
    return user.canSupervise();
  }
}
